import { render, staticRenderFns } from "./SubPanelCourse.vue?vue&type=template&id=3372cd98&scoped=true"
import script from "./SubPanelCourse.vue?vue&type=script&lang=js"
export * from "./SubPanelCourse.vue?vue&type=script&lang=js"
import style0 from "./SubPanelCourse.vue?vue&type=style&index=0&id=3372cd98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3372cd98",
  null
  
)

export default component.exports